import { useEffect, useState } from "react";

/**
 * A desk-wide screen (1024px and up), where the hub map sits beside the list.
 * Below that the map is a full-screen layer over the list. Starts true, so the
 * server and the first client render agree, and settles on mount.
 */
export function useIsDesk(): boolean {
  const [isDesk, setIsDesk] = useState(true);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const sync = () => setIsDesk(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);
  return isDesk;
}
